import React from 'react';
import { AlertTriangle } from 'lucide-react';
import EmptyState from './EmptyState';
import { GanttVista } from './ProyectoGanttView';
import useDatosVistaGeneral from './utils/useDatosVistaGeneral';
import { SIDEBAR_WIDTH } from './gantt/constants';

// ---------- Gantt general del modulo (/proyectos/gantt) ----------
//
// Es el mismo Gantt de un proyecto (GanttVista: escalas con camara, Ajustar,
// agrupar, dependencias, hitos, slide-over) alimentado con las tareas de todos
// los proyectos, igual que la vista general. Agrupa por proyecto de entrada,
// con una barra por proyecto y sus hitos encima. La ruta critica solo existe
// dentro de un proyecto.

const GanttGlobalView = () => {
  const { loading, error, contexto } = useDatosVistaGeneral();

  if (error) {
    return (
      <div className="h-full flex items-center justify-center bg-white">
        <EmptyState icon={AlertTriangle} title={error} variant="centered" />
      </div>
    );
  }

  if (loading) {
    return (
      <div className="relative h-full flex flex-col bg-white">
        <div className="flex items-center gap-2 px-6 pt-4 pb-3 border-b border-slate-200/60 skeleton">
          {[56, 64, 220, 180].map((w, i) => (
            <div key={i} className="h-6 bg-slate-100 rounded" style={{ width: w }} />
          ))}
        </div>
        <div className="flex-1 flex min-h-0">
          <div className="flex-shrink-0 border-r border-slate-200/60 p-3 space-y-2 skeleton" style={{ width: SIDEBAR_WIDTH }}>
            {[...Array(7)].map((_, i) => (
              <div key={i} className="h-5 bg-slate-100 rounded" style={{ width: `${55 + (i * 11) % 35}%` }} />
            ))}
          </div>
          <div className="flex-1 overflow-hidden p-3 space-y-2 skeleton">
            {[...Array(7)].map((_, i) => (
              <div
                key={i}
                className="h-5 bg-slate-100 rounded"
                style={{ width: `${30 + (i * 13) % 50}%`, marginLeft: `${(i * 8) % 40}%` }}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return <GanttVista contexto={contexto} rutaBase="/proyectos/gantt" />;
};

export default GanttGlobalView;
